import { render, staticRenderFns } from "./MetalPricing.vue?vue&type=template&id=1e8cf8ff&scoped=true&"
import script from "./MetalPricing.vue?vue&type=script&lang=js&"
export * from "./MetalPricing.vue?vue&type=script&lang=js&"
import style0 from "./MetalPricing.vue?vue&type=style&index=0&id=1e8cf8ff&scoped=true&lang=css&"
import style1 from "./MetalPricing.vue?vue&type=style&index=1&lang=css&"
import style2 from "./MetalPricing.vue?vue&type=style&index=2&id=1e8cf8ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8cf8ff",
  null
  
)

export default component.exports